import { Injectable, signal, inject } from '@angular/core';
import { ContactFabComponent } from '@components/contact-fab/contact-fab.component';
import { FeatureFlagEnum } from '@models/enums/feature-flag.enum';
import { FeatureFlagService } from '@services/feature-flag/feature-flag.service';

export type ContactModalType = 'call' | 'text' | 'email';
export type fabAlignment = 'left' | 'right' | 'center';

export interface ContactData {
  contact: string;
  description: string;
  first: string;
  last: string;
  zip: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  //feature flag
  private readonly featureFlagService = inject(FeatureFlagService);

  fab: ContactFabComponent | null = null;

  readonly modalType = signal<ContactModalType | null>(null);

  formValues = signal<ContactData>({
    contact: '',
    description: '',
    first: '',
    last: '',
    zip: '',
  });

  setType(type: ContactModalType): void {
    this.modalType.set(type);
  }

  setZip(zip: string | undefined): void {
    this.formValues.update((values) => ({ ...values, zip: zip ?? '' }));
  }

  openFab(target: HTMLElement, alignment?: fabAlignment) {
    if (!this.featureFlagService.isFeatureActive(FeatureFlagEnum.CHAT_BUBBLE))
      // feature flag
      return;

    this.fab?.openAt(target, alignment);
  }
}
